/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  Spinner,
  UncontrolledCollapse,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//i18n
import { withTranslation } from "react-i18next";

// actions
import { logoutUser } from "../../../store/auth/login/actions";
import { updateAvailability } from "../../../store/availability/actions";
import { resetObj } from "../../../store/operator/actions";
import { resetHeaderObj } from "../../../store/header/actions";
import { setInitialStateManagerPanel } from "../../../store/manager/actions";

// Components
import ProfilePicture from "../../Common/ProfilePicture";
import { useMemo } from "react";
import {
  convertSlaTime,
  getAvailability,
} from "../../../Libs/CustomMethods/customMethods";

const ProfileMenu = ({ t, onclick }) => {
  //Dispatiching states
  const dispatch = useDispatch();
  const history = useHistory();

  const { data, loadingLogout } = useSelector((state) => state.Login);
  const {
    loadingDeleteAvailability,
    dataAvailability,
    successDeleteAvailability,
    successUpdateAvailability,
    errorAvailability,
  } = useSelector((state) => state.Availability);

  const { start_time: startTime } =
    useSelector((state) => state.Metrics?.data?.status) || {};

  const { mainTheme } = useSelector((state) => state.Layout);

  const activeAvailabilityId = useSelector(
    (state) => state.Availability.activeAvailability
  );

  const activeAvailability = useMemo(() => {
    if (activeAvailabilityId) {
      return getAvailability(data?.availabilities, activeAvailabilityId);
    }
    return null;
  }, [data?.availabilities, activeAvailabilityId]);

  const [menu, setMenu] = useState(false);
  const [availabilityMenu, setAvailabilityMenu] = useState(false);
  const [modal, setModal] = useState(false);
  const [avail, setAvail] = useState(false);
  const [status, setStatus] = useState(localStorage.getItem("status"));
  const [timer, setTimer] = useState(null);
  const [timerControl, setTimerControl] = useState(Date.now());
  const timeOutControl = useRef(null);

  const toggleModal = () => {
    setModal(!modal);
    removeBodyCss();
  };
  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const toggle = () => {
    setMenu(!menu);
  };

  const [dropdownOpenAway, setdropdownOpenAway] = useState(false);
  const [dropdownOpenBacksoon, setDropdownOpenBacksoon] = useState(false);

  const toggleAway = () => setdropdownOpenAway((prev) => !prev);
  const toggleBacksoon = () => setDropdownOpenBacksoon((prev) => !prev);

  const updateTimer = () => {
    if (startTime) {
      const start = new Date(startTime).getTime();
      const secs = parseInt((Date.now() - start) / 1000) || 0;
      setTimer(secs);
    }
    setTimerControl(Date.now());
  };

  useEffect(() => {
    if (history.location.pathname !== "/chats") return;

    timeOutControl.current = setTimeout(updateTimer, 1000);
    return () => {
      clearTimeout(timeOutControl.current);
    };
  }, [startTime, history.location.pathname, timerControl]);

  useEffect(() => {
    updateTimer();
  }, [startTime, activeAvailabilityId]);

  const timerFormat = useMemo(() => {
    return convertSlaTime(timer, { withSummary: true });
  }, [timer]);

  // handleValidSubmit
  const handleLogout = () => {
    dispatch(resetObj());
    dispatch(resetHeaderObj());
    dispatch(setInitialStateManagerPanel());
    dispatch(logoutUser(history));
    localStorage.removeItem("status");
  };

  useEffect(() => {
    successUpdateAvailability && setStatus(localStorage.getItem("status"));

    dropdownOpenAway && setdropdownOpenAway(false);
    dropdownOpenBacksoon && setDropdownOpenBacksoon(false);
  }, [successUpdateAvailability]);

  const handleUpdateStatus = (availId, availName) => {
    availId && dispatch(updateAvailability(availId, availName));
  };
  let showToast = function (type, msg) {
    toastr[type](msg);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onShown: () => setModal(false),
  };

  useEffect(() => {
    if (successDeleteAvailability) {
      showToast(
        "success",
        dataAvailability.message === "availabilities deleted" &&
          t("availabilities deleted")
      );
    }
  }, [successDeleteAvailability]);

  useEffect(() => {
    if (errorAvailability) {
      showToast(
        "error",
        errorAvailability === "not found"
          ? t("not found")
          : errorAvailability === "Your session has expired"
          ? t("Your session has expired")
          : errorAvailability ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
    }
  }, [errorAvailability, t, dispatch]);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center">
            {data && data.user && (
              <ProfilePicture
                name={data.user.name}
                src={data.user.url_avatar}
                sizePx={40}
                style={{
                  left: "39px",
                  top: "42px",
                  textShadow: "2px 2px black",
                }}
                t={t}
                isProfile
                isAvail
              />
            )}
            <div className="d-flex container-name-timer">
              <span className="name">{data?.user?.name}</span>
              {history.location.pathname === "/chats" && (
                <span className={`timer ${activeAvailability?.type}-timer`}>
                  {timerFormat?.summary ?? "-"}
                </span>
              )}
            </div>
            <i className="mdi mdi-chevron-down d-none dnone"></i>
          </div>
        </DropdownToggle>
        <DropdownMenu right>
          {data?.availabilities && (
            <Dropdown
              direction="right"
              isOpen={availabilityMenu}
              toggle={() => setAvailabilityMenu(!availabilityMenu)}
            >
              <DropdownToggle
                className="dropdown-item avilability text-muted"
                caret
                id="toggler"
              >
                <i className="bx bx-time-five font-size-16 text-muted align-middle mr-1"></i>
                {t("Status")}
                <i className="mdi mdi-chevron-down ml-1"></i>
              </DropdownToggle>
              <UncontrolledCollapse toggler="#toggler">
                {data.availabilities.map((fixedAvail, key) => (
                  <div
                    key={key}
                    style={{
                      backgroundColor:
                        fixedAvail.name === status &&
                        (mainTheme === "dark" ? "#32394E" : "#F8F9FA"),
                    }}
                    className="user-chat dropdown-item btn"
                  >
                    {fixedAvail?.children?.length > 0 &&
                    fixedAvail?.children[0]?.type === "backsoon" ? (
                      <Dropdown
                        direction="right"
                        isOpen={dropdownOpenBacksoon}
                        toggle={toggleBacksoon}
                      >
                        <DropdownToggle
                          className="dropdown-item avilability p-0 caret text-muted"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <i className="bx bxs-time-five text-warning font-size-16 align-middle mr-2"></i>
                          {t(fixedAvail.name)}
                          <i className="mdi mdi-chevron-down ml-1"></i>
                        </DropdownToggle>

                        <DropdownMenu className="scroll">
                          {fixedAvail.children.map((child, keyChild) => (
                            <div
                              className="user-chat dropdown-item btn"
                              key={keyChild}
                              onClick={() => {
                                handleUpdateStatus(
                                  {
                                    availability_id: child.id,
                                  },
                                  fixedAvail.name
                                );
                              }}
                            >
                              <i className="bx bxs-time-five text-warning font-size-16 align-middle mr-2"></i>
                              {child.name}
                            </div>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    ) : fixedAvail?.children?.length > 0 &&
                      fixedAvail?.children[0]?.type === "away" ? (
                      <Dropdown
                        direction="right"
                        isOpen={dropdownOpenAway}
                        toggle={toggleAway}
                      >
                        <DropdownToggle
                          className="dropdown-item avilability p-0 caret text-muted"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <i className="bx bxs-minus-circle text-danger font-size-16 align-middle mr-2"></i>
                          {t(fixedAvail.name)}
                          <i className="mdi mdi-chevron-down ml-1"></i>
                        </DropdownToggle>

                        <DropdownMenu className="scroll">
                          {fixedAvail?.children?.map((child, keyChild) => (
                            <div
                              className="user-chat dropdown-item btn"
                              key={keyChild}
                              onClick={() => {
                                handleUpdateStatus(
                                  {
                                    availability_id: child.id,
                                  },
                                  fixedAvail.name
                                );
                              }}
                            >
                              <i className="bx bxs-minus-circle text-danger font-size-16 align-middle mr-2"></i>
                              {child.name}
                            </div>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    ) : (
                      <div
                        key={key}
                        onClick={() => {
                          handleUpdateStatus(
                            {
                              availability_id: fixedAvail.id,
                            },
                            fixedAvail.name
                          );
                        }}
                        style={{
                          backgroundColor:
                            data &&
                            data.availabilities &&
                            data.availabilities.name &&
                            "#32394E",
                        }}
                        className="p-0"
                      >
                        <i
                          className={`bx ${
                            fixedAvail.online === "1"
                              ? "bxs-check-circle"
                              : fixedAvail.name === "Volto logo"
                              ? "bxs-time-five"
                              : "bxs-minus-circle"
                          } font-size-16 ${
                            fixedAvail.online === "1"
                              ? "text-success"
                              : fixedAvail.name === "Volto logo"
                              ? "text-warning"
                              : "text-danger"
                          } align-middle mr-2`}
                        ></i>
                        {t(fixedAvail.name)}
                      </div>
                    )}
                  </div>
                ))}
                <hr className="dropdown-divider" />
              </UncontrolledCollapse>
            </Dropdown>
          )}
          {data && data.permissions && data.permissions["user-profile"] && (
            <Link to={`/edit-profile`}>
              <div className="dropdown-item btn dropdown-item">
                <i className="bx bx-user font-size-16 align-middle mr-1"></i>
                {t("Profile")}
              </div>
            </Link>
          )}
          <DropdownItem tag="a" href="#" onClick={onclick}>
            <i className="bx bx-wrench font-size-16 align-middle mr-1"></i>
            {t("Settings")}
          </DropdownItem>
          <hr className="dropdown-divider" />
          <DropdownItem
            onClick={() => {
              setAvail(false);
              toggleModal();
            }}
          >
            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {t("Logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Modal isOpen={modal}>
        <div className="modal-body text-center font-size-18">
          {avail
            ? t("Do you want to delete this status ?")
            : t("Do you want to leave the platform ?")}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={toggleModal}
            className="btn btn-danger waves-effect"
            data-dismiss="modal"
            style={{ backgroundColor: "#f14646" }}
          >
            {t("No")}
          </button>

          {loadingLogout || loadingDeleteAvailability ? (
            <button
              type="button"
              className="btn btn-secondary waves-effect waves-light"
              disabled={true}
              style={{
                cursor: "no-drop",
              }}
            >
              <Spinner
                size="sm"
                animation="border"
                style={{
                  height: "18px",
                  width: "18px",
                }}
              />
            </button>
          ) : (
            <button
              onClick={handleLogout}
              type="button"
              className="btn btn-secondary waves-effect waves-light"
            >
              <Link
                to="#"
                style={{ color: mainTheme === "light" ? "white" : "black" }}
              >
                {t("Yes")}
              </Link>
            </button>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(memo(ProfileMenu));
